import { render, staticRenderFns } from "./CompanyUserCreateDetailsTab.vue?vue&type=template&id=77fd266c"
import script from "./CompanyUserCreateDetailsTab.vue?vue&type=script&lang=ts"
export * from "./CompanyUserCreateDetailsTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports